import { spacing } from "../../../stitches.config";
import { ButtonLink } from "../../Common/ButtonLink";
import { Section } from "../../Common/Layout";

export const SecondaryActions = ({
  actions,
}: {
  actions: { onClick: () => void; text: string; disabled?: boolean }[];
}) => {
  return (
    <Section gap={spacing.s}>
      {actions.map(({ text, onClick, disabled }) => (
        <ButtonLink
          key={text}
          onClick={onClick}
          styleVariant="primary"
          size="small"
          style={{
            padding: 0,
            textAlign: "left",
            height: "auto",
            marginTop: spacing.s.toString(),
          }}
          disabled={disabled}
        >
          {text}
        </ButtonLink>
      ))}
    </Section>
  );
};

export default SecondaryActions;
